import { render, staticRenderFns } from "./AppSearchResult.vue?vue&type=template&id=632fe882"
import script from "./AppSearchResult.vue?vue&type=script&lang=js"
export * from "./AppSearchResult.vue?vue&type=script&lang=js"
import style0 from "./AppSearchResult.vue?vue&type=style&index=0&id=632fe882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports